import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { I18nPipe } from '@boshared';
import { GlobalFooterModule } from '@delon/abc/global-footer';
import { DA_SERVICE_TOKEN } from '@delon/auth';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'layout-passport',
  template: `
    <div class="container">
      <div class="bg">
        <div class="logo-container">
          <img class="logo" src="./assets/icon/logo_smallGP.png" />
        </div>
      </div>
      <div class="wrap">
        <div class="top">
          <div class="title">{{ 'app.title' | i18n }}</div>
        </div>
        <router-outlet />
        <global-footer> <i nz-icon nzType="copyright"></i> 2025 Green Pulse. All rights reserved. </global-footer>
      </div>
    </div>
  `,
  styleUrls: ['./passport.component.less'],
  imports: [RouterOutlet, GlobalFooterModule, NzIconModule, I18nPipe]
})
export class LayoutPassportComponent implements OnInit {
  private tokenService = inject(DA_SERVICE_TOKEN);

  ngOnInit(): void {
    this.tokenService.clear();
  }
}
